import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AnimationOptions } from 'ngx-lottie';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

import html2pdf from 'html2pdf.js';
import html2canvas from 'html2canvas';
import { GlobalDataService } from 'src/app/services/data/global-data.service';

@Component({
  selector: 'app-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.sass']
})
export class CertificationComponent {


  @ViewChild('certificateRef') certificateRef!: ElementRef;

  wildCards = [];


  title = 'AUTH.PASSWORD-RECOVER'
  processing = false

  options: AnimationOptions = {
    path: '/assets/animations/loading.json',
  }

  data = null

  row = null

  selectedTemplate = null

  constructor(
    private auth: AuthService,
    private router: Router,
    protected route: ActivatedRoute,
    public utils: UtilsService,
    public dataservice: GlobalDataService
  ) {

    this.dataservice.core.wildcards().subscribe(data => this.wildCards = data)
    this.route.params.subscribe(params => {
      if ('data' in params) {
        this.data = params['data']
        this.dataservice.core.templateToSelect().subscribe(data =>{
          this.selectedTemplate = data[0]
          console.log(this.selectedTemplate);

          this.getInfoCourse()
        })
      }
    })
  }



  getInfoCourse() {
    this.processing = true
    this.auth.certificate({ data: this.data }).subscribe(
      data => {
        this.row = {
          user_: data['user'],
          el_course: data['course']
        };
        console.log(this.row);

        this.row.enrollment_at = new Date(data['user'].enrrollments[0].enrolled_at).toLocaleDateString()
        this.generatePdf(this.selectedTemplate, '')
        this.processing = false
      }
    )
  }


  replaceWildcard(texto, variable) {

    const regex = /\[var:(\w+)\]/;

    let wCard = this.wildCards.find(w => w.key_ === variable.match(regex)[1]);
    let patron = new RegExp(variable.replace(/[\[\]]/g, '\\$&'), 'g');

    console.log(texto);
    console.log(patron);
    console.log(wCard.content);



    if (wCard.type_ === 'TEXT') {
      return texto.replace(patron, wCard.content);
    } else {
      /* let content = texto.replace(patron, wCard.content); */
      let parts = wCard.content.split('.')





      switch (parts[0]) {
        case 'el_course':

          if (parts[1] === 'final_note') {
            if ('unitTestsAverageScore' in this.row) {
              return texto.replace(patron, this.row.unitTestsAverageScore)
            } else {
              return texto.replace(patron, 'Sin nota');
            }
          }else{
            return texto.replace(patron, this.row.el_course[parts[1]])
          }

        /*   if (this.courseDetail !== null) {
            return texto.replace(patron, this.courseDetail[parts[1]])
          } else {
            if (this.row) {
              //! todo change
              return texto.replace(patron, '')

            } else {
              return texto.replace(patron, 'Sin curso')
            }
          } */
        /* case 'el_course_unit':
          if (this.UnitDetail !== null) {
            return texto.replace(patron, this.UnitDetail[parts[1]])
          } else {
            if ('course_units' in this.itemSelection) {
              return texto.replace(patron, this.itemSelection.course_units.map(u => u[parts[1]]).join(', '))
            } else {
              return texto.replace(patron, 'Sin unidades')
            }

          } */

      /*   case 'el_test':


          if (parts[1] === 'name_') {
            if (this.testDetail !== null) {
              return texto.replace(patron, this.testDetail.poll.title)
            } else {
              return texto.replace(patron, 'Sin Evaluaciones')
            }
          }

          if (this.testDetail !== null) {
            return texto.replace(patron, this.testDetail[parts[1]])
          } else {
            if ('tests' in this.itemSelection) {
              return texto.replace(patron, this.itemSelected.tests.map(u => u.name_).join(', '))
            } else {
              if ('course_units' in this.itemSelection) {
                if ('tests' in this.itemSelection.course_units[0]) {
                  return texto.replace(patron, this.itemSelection.course_units.map(cu => cu.tests[0].test.title).join(', '))
                }
              }
              return texto.replace(patron, 'Sin Evaluaciones')
            }

          }
 */
        case 'user_':
          if (parts[1] === 'user_post') {
            return texto.replace(patron, this.row.user.post.name_);
          }
          if (parts[1] === 'enrolled_at') {
            return texto.replace(patron, this.row[parts[1]])
          }

          return texto.replace(patron, this.row.user_[parts[1]])

         /*  if (this.userDetail !== null) {
            return texto.replace(patron, this.userDetail[parts[1]])
          } else {
            if ('user' in this.itemSelection) {
              return texto.replace(patron, this.itemSelection.user[parts[1]])
            } else {
              return texto.replace(patron, 'Sin Usuario')
            }
          } */



        default:
          return texto
          break;
      }

    }



  }


  generatePdf(type, data) {


    let text = type.html;
    let match = /\[var:[^\]]+\]/g;

    const div = document.getElementById('certificate');



      let patrones = text.match(match);



      if (patrones) {
        patrones.forEach(patron => {
          text = this.replaceWildcard(text, patron);
        });
      }


      div.innerHTML = text;






  }

  downloadPDF() {
    const element = this.certificateRef.nativeElement;
    const opt = {
      margin: 0.5,
      filename: 'certificado.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
    };
    html2pdf().from(element).set(opt).save();
  }

  downloadImage() {
    const element = this.certificateRef.nativeElement;
    html2canvas(element, { scale: 2 }).then((canvas) => {
      const link = document.createElement('a');
      link.download = 'certificado.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  }
}
